import { forwardRef, useCallback, useEffect, useImperativeHandle, useRef, useState } from 'react';
import { Space } from 'tdesign-react';

import { CardFormComponent, IFormItemProps } from '@/components';
import { PageIds } from '@/const/tip';
import { AiPrompt, AiVideoType, VideoImage } from '@/interface/aigc';
import { AigcVideoDialogProps } from '@/material/AigcVideoDialog';
import { orgConfigs } from '@/utils/orgFormConfig';

import { aigcVideoFormCard } from './form-config';
import styles from './index.module.less';

interface AigcVideoInfoProps {
  data: AigcVideoDialogProps['data'];
  getPrompt?: (prompt: string) => void;
}

export interface AigcVideoInfoRef {
  submitForm: () => void;
  getVideoInfo: () => any;
}

interface IFormData {
  type?: AiVideoType;
  text?: AiPrompt;
  duration?: number;
  imageUrl?: VideoImage[];
}

const AigcVideoInfo = forwardRef<AigcVideoInfoRef, AigcVideoInfoProps>((props, ref) => {
  const { data, getPrompt } = props;
  const cardFormRef1 = useRef<any>(null);
  const initData: IFormData = {
    type: AiVideoType.IMAGE,
    text: { prompt: data?.promptText },
    duration: 5,
    imageUrl: [],
  };
  const [formData, setFormData] = useState<IFormData>(initData);

  useEffect(() => {
    setFormData({ ...formData, text: { prompt: data?.promptText } });
    getPrompt?.(data?.promptText);
  }, [data?.promptText]);

  useImperativeHandle(ref, () => ({
    submitForm: handleSave,
    getVideoInfo: () => ({ ...formData }),
  }));

  const onSubmit = async (values: IFormData) => {
    setFormData(values);
  };

  const handleSave = () => {
    onSubmit(formData);
  };

  const onValuesChange = useCallback((content: IFormData) => {
    const newData = { ...formData, ...content };
    getPrompt?.(newData.text?.prompt || '');
    setFormData(newData);
  }, [formData]);

  const refactorFieldsConfig = (config: IFormItemProps[], values: IFormData) => {
    const tempConfigs = orgConfigs(config, values, {});
    return tempConfigs?.map((e) => {
      if (e.props === 'imageUrl') {
        return {
          ...e,
          render: values?.type === AiVideoType.TEXT ? 'hidden' : 'customAigcFrame',
        };
      }
      return {
        ...e,
      };
    });
  };

  return (
    <div id="nova-edit-container" className={styles.container} >
      <Space direction="vertical" size="large" style={{ width: '100%' }}>
        <CardFormComponent
          cRef={cardFormRef1}
          key={'aigc-video'}
          title={''}
          pageId={PageIds.AIGC_INFO}
          formData={formData}
          fieldsConfig={aigcVideoFormCard.fieldsConfig}
          formConfig={{
            layout: 'vertical',
            labelWidth: '100%',
            labelAlign: 'top',
            onValuesChange,
          }}
          onSubmit={onSubmit}
          extendControlConfig={{
            refactorFieldsConfig: config => refactorFieldsConfig(config, formData),
          }}
        />
      </Space>
    </div>
  );
});

export default AigcVideoInfo;
